export default __webpack_public_path__ + "static/media/SAL2.e1cbd992.jpg";